import actionTypes from "../actionTypes";

export const setMetrics = (metrics) => {
  return {
    type: actionTypes.SET_CURRENT_METRICS,
    metrics,
  };
};
